import { AlertOctagon } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { getApiErrorMessage } from "@/api/client";

export function ErrorState({
  error,
  onRetry,
}: {
  error?: unknown;
  onRetry?: () => void;
}) {
  const message = error ? getApiErrorMessage(error) : "Something went wrong.";
  return (
    <div className="flex flex-col items-center justify-center gap-2 py-16 text-center">
      <AlertOctagon className="mb-1 h-8 w-8 text-danger-500" />
      <p className="font-medium text-ink">Couldn't load this data</p>
      <p className="max-w-sm text-sm text-ink-muted">{message}</p>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry} className="mt-2">
          Try again
        </Button>
      )}
    </div>
  );
}
